import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import FormLabel from '@material-ui/core/FormLabel';
import { makeStyles, withStyles } from '@material-ui/core/styles';

const DialogTitle = withStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(),
  },
}))(MuiDialogTitle);

const DialogActions = withStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing(),
    paddingBottom: theme.spacing(),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  content: {
    width: 325,
    padding: theme.spacing(),
  },
  field: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: theme.spacing(),
  },
  detail: {
    padding: theme.spacing(),
    color: theme.palette.common.black,
  },
  label: {
    width: 130,
  },
}));

type Props = Pick<DialogProps, 'open' | 'onClose'> & {
  confirmButtonText?: string;
  cancelButtonText?: string;
  title: string;
  onConfirm: (userId: string) => void;
  onCancel?: () => void;
  contentText: string;
  unmatchUser: {
    id: string;
    name: string;
    email: string;
    mobileNum: string;
  };
};

export default function AlertDifferentAccountDialog({
  cancelButtonText,
  confirmButtonText,
  onClose,
  onCancel,
  onConfirm,
  open,
  title,
  contentText,
  unmatchUser,
}: Props) {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose}>
      <div className={classes.content}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{contentText}</DialogContentText>
          <div className={classes.field}>
            <FormLabel className={classes.detail}>
              {unmatchUser.mobileNum}
            </FormLabel>
            <FormLabel className={classes.detail}>
              {unmatchUser.email}
            </FormLabel>
          </div>
        </DialogContent>
        <DialogActions>
          {cancelButtonText && onCancel && (
            <Button onClick={onCancel} variant="contained" autoFocus>
              {cancelButtonText}
            </Button>
          )}
          <Button
            onClick={() => onConfirm(unmatchUser.id)}
            color="primary"
            autoFocus
          >
            {confirmButtonText || 'Confirm'}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
}
